import ICTTrainingOffers from "./ICTTrainingOffers";

const ICTTraining = () => {
  return (
    <section className="solution-item-page">
      <ICTTrainingOffers />
    </section>
  );
};

export default ICTTraining;
